<template>
  <v-container fluid class="paymethod-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/paymethod/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="paymethods-table"
              show-select
              single-select
              item-key="_id"
              sort-by="paymethodname"
              :footer-props="footer"
              :headers="headers"
              :items="paymethods"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this PayMethod?
                    </v-card-title>

                    <v-card-text>
                      {{ deletePayMethod.paymethodname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletePayMethod)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.paymethodimage" size="35">
                  <img v-bind:src="item.paymethodimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.paymethodname[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.paymethodname="{ item }">
                <a class="primaryConst--text">{{ item.paymethodname }}</a>
              </template>
              <template v-slot:item.paymethodemail="{ item }">
                <a class="primaryConst--text">{{ item.paymethodemail }}</a>
              </template>
              <template v-slot:item.paymethodid="{ item }">
                {{ item.paymethodid }}
              </template>
              <template v-slot:item.company>
                Flatlogic
              </template>
              <template v-slot:item.paymethodstatus="{ item }">
                <v-chip
                  :color="!item.paymethodstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.paymethodstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PayMethodList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deletePayMethod: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Type', value: 'paymethodtype' },
        { text: 'Name', value: 'paymethodname' },
        { text: 'Code', value: 'paymethodcode' },
        { text: 'Status', value: 'paymethodstatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      switch1: true,
      paymethodid: ['admin', 'paymethod'],
      editedIndex: -1,
      editedItem: {
        paymethodname: '',
        image: '',
        paymethodid: '',
        company: '',
        paymethodtype: '',
        paymethodstatus: '',
        create: '',
      },
      defaultItem: {
        paymethodname: '',
        image: '',
        paymethodid: '',
        company: '',
        paymethodtype: '',
        paymethodstatus: '',
        create: '',
      },
      images: [
        require('@/assets/img/user/avatars/1.png'),
        require('@/assets/img/user/avatars/2.png'),
        require('@/assets/img/user/avatars/3.png'),
        require('@/assets/img/user/avatars/4.png'),
        require('@/assets/img/user/avatars/5.png'),
      ],
      
      text: '',
      //notification: '<p class="font-weight-bold mb-0">This page is only available in Vue Material Admin Full with ' +
      //    '<a rel="noreferrer noopener" target="_blank" class="white--text text-decoration-none" href="https://flatlogic.com/templates/sing-app-vue-node-js">NodeJS</a>/' +
      //    '<a rel="noreferrer noopener" target="_blank" class="white--text text-decoration-none" href="https://flatlogic.com/templates/sing-app-vue-laravel">PHP</a> backend integration!</p>'
    }
  },

  computed: {
    ...mapState('PayMethod', ['paymethods', 'isReceiving', 'isDeleting', 'idToDelete', 'paymethodsMessage', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit paymethod'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    paymethodsMessage() {
      this.notification = this.paymethodsMessage;
      this.addSuccessNotification()
    }
  },
  created () {
    this.getPayMethodsRequest()
    this.addSuccessNotification()
  },

  methods: {
    ...mapActions('PayMethod', [
      "getPayMethodsRequest",
      "deletePayMethodRequest",
      "updatePayMethodRequest",
    ]),

    editItem(item) {
      this.$router.push({ name: 'PayMethodEdit', params: item })
    },

    deleteItem(item) {

      //const pos = this.paymethods.map(function(paymethod) { return paymethod._id; }).indexOf(item._id);
      //this.paymethods.splice(pos, 1);
      this.deletePayMethodRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletePayMethod = {
        _id: item._id,
        paymethodname: item.paymethodname,
      }
    },
    close () {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
      })
    },


    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
